import { useMemo } from "react";
import ActionWrapper from "Common/DataTable/ActionWrapper";
import EditBtn from "Common/DataTable/EditBtn";
import DeleteBtn from "Common/DataTable/DeleteBtn";
import ViewBtn from "Common/DataTable/ViewBtn";
import ChackInBtn from "Common/DataTable/ChackInBtn";
import { Link } from "react-router-dom";

const useRoomTableConfig = ({
    data = [],
    page = 1,
    limit = 10,
    canShowAction = false,
    refetch = () => { },
    config = {},
    IsEdit = true,
    IsDelete = true,
    IsModel = false,
    isView = false,
    IsChackIn = false,
    IsEditDisble = false,
    IsEditDisbleKey = ''
}) => {

    console.log("IsEditDisble",IsEditDisbleKey)
    const { entityName, editUrl, idKey, displayFields, deleteApi, ViewUrl = "", ChackInUrl = "", IsCheckInDisableKey = '' } = config;

    const formattedData = useMemo(() => {
        return data.map((item, index) => {
            const row = { rowNo: (page - 1) * limit + index + 1 };
            displayFields.forEach((field) => {
                row[field.accessor] = item[field.dataKey];
            });
            if (IsEditDisble) row[IsEditDisbleKey] = item[IsEditDisbleKey];
            row[IsCheckInDisableKey] = item[IsCheckInDisableKey];
            row[idKey] = item[idKey];
            return row;
        });
    }, [data, page, limit, displayFields, idKey]);

    const columns = useMemo(() => {
        const baseColumns = [
            ...displayFields.map(({ Header, accessor, isImage }) => ({
                Header,
                accessor,
                Cell: ({ value, column }) =>
                    isImage && value ? (
                        <img
                            src={
                                value
                                    ? `${value}`
                                    : "data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' width='80' height='80'><rect width='100%' height='100%' fill='%23eee'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-size='12' fill='%23999'>no image</text></svg>"
                            }
                            className="img-fluid avatar lg rounded"
                            alt={column.Header || "Thumbnail"}
                            onError={(e) => {
                                e.currentTarget.src =
                                    "data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' width='80' height='80'><rect width='100%' height='100%' fill='%23eee'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-size='12' fill='%23999'>no image</text></svg>";
                            }}
                        />
                    ) : (
                        value
                    ),
            })),
        ];

        if (!canShowAction || (!IsEdit && !IsDelete && !isView && !IsModel && !IsChackIn)) return baseColumns;

        return [
            {
                Header: "No",
                accessor: "rowNo",
            },
            {
                Header: "Action",
                accessor: "action",
                sortable: false,
                Cell: ({ row }) => (
                    <ActionWrapper>
                        {IsEdit && <EditBtn url={`${editUrl}/${row.original[idKey]}`} disabled={row.original[IsEditDisbleKey]} />}
                        {isView && <ViewBtn url={`${ViewUrl}/${row.original[idKey]}`} />}
                        {IsChackIn && row.original[IsCheckInDisableKey] == "2" && <ChackInBtn url={`${ChackInUrl}/${row.original[idKey]}`} />}
                        {IsDelete && (<DeleteBtn id={row.original[idKey]} fetchData={refetch} apiDeleteFunction={deleteApi} itemName={entityName} />)}
                        {IsModel?.show && (<Link to={`${editUrl}/${row.original[idKey]}`} id={row.original[idKey]} className="btn btn-primary">{IsModel.val}</Link>)}
                    </ActionWrapper>
                ),
            },
            ...baseColumns,

        ];
    }, [displayFields, canShowAction, refetch, editUrl, idKey, entityName, deleteApi, IsEdit, IsDelete, isView, ViewUrl]);

    return { formattedData, columns };
};

export default useRoomTableConfig;

